module.exports = __webpack_public_path__ + "media/images/home/okra_inactive-6d90d2f12ec547f3ea4d1230ef28db78.png";